// extracted by mini-css-extract-plugin
export var anchor = "blog-module--anchor--21bb4";
export var border = "blog-module--border--c671d";
export var embededAsset = "blog-module--embededAsset--30b43";
export var embededAssetPDF = "blog-module--embededAssetPDF--5b6cc";
export var embededAssetWrapper = "blog-module--embededAssetWrapper--e2ed9";
export var floatingImage = "blog-module--floatingImage--07ea0";
export var heading = "blog-module--heading--f1903";
export var heading2 = "blog-module--heading2--1a842";
export var heading3 = "blog-module--heading3--349aa";
export var heading4 = "blog-module--heading4--904d0";
export var heading5 = "blog-module--heading5--4c427";
export var heading6 = "blog-module--heading6--0267b";
export var listItem = "blog-module--listItem--f7fc1";
export var orderedList = "blog-module--orderedList--47a6e";
export var paragraph = "blog-module--paragraph--3d9af";
export var table = "blog-module--table--ca19a";
export var tableHeader = "blog-module--tableHeader--08f47";
export var title = "blog-module--title--a4068";
export var unorderedList = "blog-module--unorderedList--fbfad";
export var wrapper = "blog-module--wrapper--83828";